import React from 'react';
import noDataFound from '../../../../assets/images/icons/no-data-found.png';
import { Button, ButtonGroup, Dropdown } from 'react-bootstrap';
import { BsPencilSquare, BsThreeDotsVertical } from "react-icons/bs";
import SubCategories from './sub-categories';

const Datatable = ({ columns, data }) => {
  return (
    <div className='datatable h-auto mb-3'>
      <table className='table mb-0'>
        <thead className='table-head'>
          <tr>
            {
              columns && columns.map((th_item, index) => {
                return (
                  <th key={index} className={index === 0 ? 'ps-5 bg-table-head' : index === columns.length - 1 ? 'pe-5 bg-table-head' : 'p-3 bg-table-head'}>{th_item}</th>
                )
              })
            }
          </tr>
        </thead>
        {
          data && data.length > 0 ?
            <tbody>
              {
                data && data.map((tb_items, index) => {
                  return (
                    <tr key={index} className='border-bottom'>
                      <td className='ps-5 align-middle'>{index + 1}</td>
                      <td className="align-middle">{tb_items.name}</td>
                      <td className="align-middle">
                        <SubCategories category={tb_items} />
                      </td>
                      <td className='py-1 d-flex align-items-center justify-content-end'>
                        <Button
                          variant="outline-light"
                          className='px-2 text-secondary'
                        >
                          <BsPencilSquare size={16} />
                        </Button>
                      </td>
                    </tr>
                  )
                })
              }
            </tbody>
            :
            <tbody>
              <tr>
                <td colSpan={7}>
                  <div className='no-data-found'>
                    <div className='text-center'>
                      <img src={noDataFound} alt="no-data-found" className='img-fluid' />
                      <p className='mt-3'>No Category Found</p>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
        }
      </table>
    </div>
  )
}

export default Datatable;
